import step1 from "@/modules/moduleA/statics/step1";
import step2 from "@/modules/moduleA/statics/step2";
import step3 from "@/modules/moduleA/statics/step3";
import step4 from "@/modules/moduleA/statics/step4";
import step5 from "@/modules/moduleA/statics/step5";
import step6 from "@/modules/moduleA/statics/step6";
import step7 from "@/modules/moduleA/statics/step7";
import step8 from "@/modules/moduleA/statics/step8";
import step9 from "@/modules/moduleA/statics/step9";

export const moduleA = {
  state: {
    steps: [{...step1}, {...step2}, {...step3}, {...step4}, {...step5}, {...step6}, {...step7}, {...step8}, {...step9}],
    results: [],
    scrolled:false,
    canvasImg:null,
  },
  mutations:{
    setResults(state, val){
      state.results = val
    },
    setScrolled(state, val){
      state.scrolled = val
    },
    setCanvasImg(state, val){
      state.canvasImg = val
    }
  },
  getters:{
    getSteps: (state) => (step) => {
      const data = state.steps.filter(element =>{
        return element.hasOwnProperty(step)
      })
      return data.find(element => {
        return element.hasOwnProperty(step)
      })
    }
  },
}
